/* import __COLOCATED_TEMPLATE__ from './add-conversation-topic.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';
import { type MacroAction } from 'embercom/objects/inbox/macro';

interface Signature {
  Args: {
    action: MacroAction;
  };
}

const AddConversationTopic = templateOnlyComponent<Signature>();
export default AddConversationTopic;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UseMacro::Preview::AddConversationTopic': typeof AddConversationTopic;
    'inbox2/command-k/use-macro/preview/add-conversation-topic': typeof AddConversationTopic;
  }
}
